import { localStorageGet } from './localStorage';

/** True when login role is guardian (auth-driven guardian app; not staff RBAC). */
export const isGuardianUserRole = (): boolean =>
  localStorageGet('userRole', '') === 'guardian';
